import ChatService from '../store/services/ChatService';

/**
 * Mở đúng nhóm chat và cuộn tới tin ANNOUNCEMENT (dùng scroll_to_message_id giống MessageSideBar).
 * @param {import('vue').default} vm
 * @param {{ groupId: string|number, messageId: string|number }} payload
 */
export function navigateToChatAnnouncement(vm, { groupId, messageId }) {
  const gid = String(groupId);
  const params = { page: 1, per_page: 20, group_id: gid };
  return ChatService.getChatGroups(params).then((res) => {
    if (!res || !res.data || !res.data[0]) {
      return;
    }
    const row = res.data[0];
    const g = Object.assign({}, row, { scroll_to_message_id: messageId });
    vm.$store.commit('chat/updateChatGroupSelected', g);
    const currentId = String(vm.$route.params.messenger_id || '');
    if (currentId !== gid) {
      vm.$router.push('/messenger/' + gid);
    }
  });
}
